$(function () {
  $('input[name="plan-type"]').on('change', function () {
    if ($(this).val() === 'standard') {
      $('.standard-plans-row').show();
      $('.premium-plans-row').hide();
    } else if ($(this).val() === 'premium') {
      $('.standard-plans-row').hide();
      $('.premium-plans-row').show();
    }
  });

  $('input[name="standard-plan"]').on('change', function () {
    buttonText = $(this).data('btnText');
    buttonLink = $(this).data('link');
    $('.standard-plans-row .payment-button a').text(buttonText);
    $('.standard-plans-row .payment-button a').attr('href', buttonLink);
  });

  $('input[name="premium-plan"]').on('change', function () {
    buttonText = $(this).data('btnText');
    buttonLink = $(this).data('link');
    $('.premium-plans-row .payment-button a').text(buttonText);
    $('.premium-plans-row .payment-button a').attr('href', buttonLink);
  });
});
